declare global {
  /**
   * At the moment, we use window to cache global variable data
   * Maybe we change in the future :D
   */
  interface Window {
    $gfFrame: JQuery;
    $gfFrameContents: JQuery<HTMLElement | Document | Text | Comment>;
    $gfFrameWrap: JQuery;
    $gfFrameLoader: JQuery;
    $gryffEditor: JQuery;
    $gryffBody: JQuery;
    $gfLeftSideBar: JQuery;
    $gfContainer: JQuery;
    $divContentHidden: JQuery;
    $gfResTool: JQuery;
    $divTopBar: JQuery;
    $notifiBar: JQuery;
    $divContentBk: JQuery;
  }
}

// eslint-disable-next-line
const gfFrame = () => {
  if (!window.$gfFrame || !window.$gfFrame.length) {
    window.$gfFrame = jQuery('#gfFrame');
  }
  return window.$gfFrame;
};
// eslint-disable-next-line
const gfFrameContents = () => {
  return gfFrame().contents();
};

// eslint-disable-next-line
const gfFrameLoader = () => {
  if (!window.$gfFrameLoader || !window.$gfFrameLoader.length) {
    window.$gfFrameLoader = jQuery('#gfFrameLoader');
  }
  return window.$gfFrameLoader;
};
// eslint-disable-next-line
const gfFrameWrap = () => {
  if (!window.$gfFrameWrap || !window.$gfFrameWrap.length) {
    window.$gfFrameWrap = jQuery('#gfFrameWrap');
  }
  return window.$gfFrameWrap;
};
// eslint-disable-next-line
const gfLeftSideBar = () => {
  if (!window.$gfLeftSideBar || !window.$gfLeftSideBar.length) {
    window.$gfLeftSideBar = jQuery('#gfLeftSideBar');
  }
  return window.$gfLeftSideBar;
};
// eslint-disable-next-line
const gfContainer = () => {
  if (!window.$gfContainer || !window.$gfContainer.length) {
    window.$gfContainer = jQuery('#gfContainer');
  }
  return window.$gfContainer;
};
// eslint-disable-next-line
const divContentHidden = () => {
  if (!window.$divContentHidden || !window.$divContentHidden.length) {
    window.$divContentHidden = jQuery('#divContentHidden');
  }
  return window.$divContentHidden;
};
// eslint-disable-next-line
const gfResTool = () => {
  if (!window.$gfResTool || !window.$gfResTool.length) {
    window.$gfResTool = jQuery('#gfResTool');
  }
  return window.$gfResTool;
};
// eslint-disable-next-line
const divTopBar = () => {
  if (!window.$divTopBar || !window.$divTopBar.length) {
    window.$divTopBar = jQuery('#divTopBar');
  }
  return window.$divTopBar;
};
// eslint-disable-next-line
const notifiBar = () => {
  if (!window.$notifiBar || !window.$notifiBar.length) {
    window.$notifiBar = jQuery('#notifiBar');
  }
  return window.$notifiBar;
};
// eslint-disable-next-line
const divContentBk = () => {
  if (!window.$divContentBk || !window.$divContentBk.length) {
    window.$divContentBk = jQuery('#divContentBk');
  }
  return window.$divContentBk;
};
// eslint-disable-next-line
const gryffEditor = () => {
  // Can't cache this variable because the content changes every time
  return gfFrameContents().find('.gryffeditor').first();
};
// eslint-disable-next-line
const gryffBody = () => {
  // Can't cache this variable because the content changes every time
  return gfFrameContents().find('body').first();
};

const globalVariables: { [K: string]: Function } = {
  gfFrame: gfFrame,
  gfFrameContents: gfFrameContents,
  gfFrameWrap: gfFrameWrap,
  gfFrameLoader: gfFrameLoader,
  gfLeftSideBar: gfLeftSideBar,
  gfContainer: gfContainer,
  divContentHidden: divContentHidden,
  gfResTool: gfResTool,
  divTopBar: divTopBar,
  notifiBar: notifiBar,
  gryffEditor: gryffEditor,
  gryffBody: gryffBody,
  divContentBk: divContentBk,
};

/**
 * Get global variable
 * @param variableName
 * @returns variable value: any
 */
export const getGlobalVariable = (variableName: string): any => {
  if (globalVariables[variableName]) {
    return globalVariables[variableName]();
  }
};
